// extracted by mini-css-extract-plugin
export default {"whatsapp":"Whatsapp_whatsapp__Ha9il","info":"Whatsapp_info__7A2eB","link":"Whatsapp_link__Hj8-r"};